import CloudHealth from './CloudHealth';

export default CloudHealth;
